import { render, staticRenderFns } from "./PoketimeCard.vue?vue&type=template&id=8c82f2ca&scoped=true"
import script from "./PoketimeCard.vue?vue&type=script&lang=js"
export * from "./PoketimeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c82f2ca",
  null
  
)

export default component.exports